import styled from "styled-components";

import Flexbox from "core/Flexbox";
import colors from "core/colors";

export const ProgressBarBase = styled.div`
    width: 9.45625rem;
    height: 0.25rem;
    background-color: ${colors.pebble};
    position: relative;
    margin: 0 auto 0.25rem auto;
`;

export const CurrentProgressIndicator = styled.div`
    width: 3.625rem;
    height: 0.25rem;
    background-color: ${colors.mist};
    position: absolute;
    left: 0;
    top: 0;
`;

export const ProgressArrow = styled.div`
    width: 0;
    height: 0;
    border-top: 0.3375rem solid transparent;
    border-bottom: 0.3375rem solid transparent;
    border-left: 0.375rem solid ${colors.pebble};
`;

export const ProgressBarTextWrapper = styled(Flexbox)`
    width: 9.5rem;
`;
